import { render, staticRenderFns } from "./baseproperty2.vue?vue&type=template&id=6e29132e&scoped=true&"
import script from "./baseproperty2.vue?vue&type=script&lang=js&"
export * from "./baseproperty2.vue?vue&type=script&lang=js&"
import style0 from "./baseproperty2.vue?vue&type=style&index=0&id=6e29132e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e29132e",
  null
  
)

export default component.exports